module.exports = __webpack_public_path__ + "img/section2Logo1.c30e6314.svg";